// This file is auto-generated by @hey-api/openapi-ts

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { GetAccountsData, GetAccountsResponse, CreateAccountData, CreateAccountResponse, GetAccountByIdData, GetAccountByIdResponse, GetAffiliationsData, GetAffiliationsResponse, CreateAffiliationData, CreateAffiliationResponse, DeleteAffiliationByIdData, DeleteAffiliationByIdResponse, UpdateAffiliationByIdData, UpdateAffiliationByIdResponse, GetAttendancesData, GetAttendancesResponse, SetAttendanceData, SetAttendanceResponse, CreateAuthenticationData, CreateAuthenticationResponse, GetAuthenticationsByUserIdData, GetAuthenticationsByUserIdResponse, DeleteAuthenticationFromUserData, DeleteAuthenticationFromUserResponse, GetCatalogProductsData, GetCatalogProductsResponse, GetCatalogProductByIdData, GetCatalogProductByIdResponse, UpdateCatalogProductByIdData, UpdateCatalogProductByIdResponse, GetCatalogVariantsData, GetCatalogVariantsResponse, GetCatalogVariantByIdData, GetCatalogVariantByIdResponse, UpdateCatalogVariantByIdData, UpdateCatalogVariantByIdResponse, GetCategoriesData, GetCategoriesResponse, CreateCategoryData, CreateCategoryResponse, GetCategoryByIdData, GetCategoryByIdResponse, UpdateCategoryByIdData, UpdateCategoryByIdResponse, CreateCommentData, CreateCommentResponse, DeleteCommentByIdData, DeleteCommentByIdResponse, UpdateCommentByIdData, UpdateCommentByIdResponse, GetCourseLocationsData, GetCourseLocationsResponse, CreateCourseLocationData, CreateCourseLocationResponse, GetCourseLocationByIdData, GetCourseLocationByIdResponse, DeleteCourseLocationByIdData, DeleteCourseLocationByIdResponse, UpdateCourseLocationByIdData, UpdateCourseLocationByIdResponse, GetCourseTabsResponse, GetCourseVariantsData, GetCourseVariantsResponse, CreateCourseVariantData, CreateCourseVariantResponse, GetCourseVariantByIdData, GetCourseVariantByIdResponse, GetCoursesData, GetCoursesResponse, CreateCourseData, CreateCourseResponse, GetCourseByIdData, GetCourseByIdResponse, UpdateCourseByIdData, UpdateCourseByIdResponse, GetPlannedCoursesByCourseIdData, GetPlannedCoursesByCourseIdResponse, GetPlannedCoursesByIdAndCourseIdData, GetPlannedCoursesByIdAndCourseIdResponse, GetPlannedCoursesData, GetPlannedCoursesResponse, CreatePlannedCourseData, CreatePlannedCourseResponse, GetPlannedCourseByIdData, GetPlannedCourseByIdResponse, UpdatePlannedCourseByIdData, UpdatePlannedCourseByIdResponse, CancelPlannedCourseByIdData, CancelPlannedCourseByIdResponse, GetCreditCategoriesData, GetCreditCategoriesResponse, GetCreditsData, GetCreditsResponse, GetCurrentEducatorResponse, GetEnrollmentsData, GetEnrollmentsResponse, GetEnrollmentByIdData, GetEnrollmentByIdResponse, UpdateEnrollmentByIdData, UpdateEnrollmentByIdResponse, CancelEnrollmentByIdData, CancelEnrollmentByIdResponse, CreateGradeData, CreateGradeResponse, GetGradeByIdData, GetGradeByIdResponse, DeleteGradeByIdData, DeleteGradeByIdResponse, UpdateGradeByIdData, UpdateGradeByIdResponse, GetInvoiceVatsData, GetInvoiceVatsResponse, CreateInvoiceVatData, CreateInvoiceVatResponse, GetInvoicesData, GetInvoicesResponse, CreateInvoiceData, CreateInvoiceResponse, GetInvoiceByIdData, GetInvoiceByIdResponse, OpenInvoiceByIdData, OpenInvoiceByIdResponse, GetInvoicePdfByIdData, GetInvoicePdfByIdResponse, GetInvoicePaymentsByInvoiceIdData, GetInvoicePaymentsByInvoiceIdResponse, CreateInvoicePaymentByInvoiceIdData, CreateInvoicePaymentByInvoiceIdResponse, DeleteInvoicePaymentByIdAndInvoiceIdData, DeleteInvoicePaymentByIdAndInvoiceIdResponse, GetPaymentByIdData, GetPaymentByIdResponse, GetLabelsData, GetLabelsResponse, CreateLabelData, CreateLabelResponse, GetLabelByIdData, GetLabelByIdResponse, DeleteLabelByIdData, DeleteLabelByIdResponse, UpdateLabelByIdData, UpdateLabelByIdResponse, AddLabelToOrderData, AddLabelToOrderResponse, GetLeadsData, GetLeadsResponse, CreateLeadData, CreateLeadResponse, GetLeadByIdData, GetLeadByIdResponse, DeleteLeadByIdData, DeleteLeadByIdResponse, GetMaterialGroupsData, GetMaterialGroupsResponse, CreateMaterialGroupData, CreateMaterialGroupResponse, GetMaterialGroupByIdData, GetMaterialGroupByIdResponse, DeleteMaterialGroupByIdData, DeleteMaterialGroupByIdResponse, UpdateMaterialGroupByIdData, UpdateMaterialGroupByIdResponse, GetMaterialsData, GetMaterialsResponse, CreateMaterialData, CreateMaterialResponse, DeleteMaterialByIdData, DeleteMaterialByIdResponse, UpdateMaterialByIdData, UpdateMaterialByIdResponse, GetMeetingLocationsData, GetMeetingLocationsResponse, CreateMeetingLocationData, CreateMeetingLocationResponse, GetMeetingLocationByIdData, GetMeetingLocationByIdResponse, DeleteMeetingLocationByIdData, DeleteMeetingLocationByIdResponse, UpdateMeetingLocationByIdData, UpdateMeetingLocationByIdResponse, GetMeetingsData, GetMeetingsResponse, CreateMeetingData, CreateMeetingResponse, GetMeetingByIdData, GetMeetingByIdResponse, DeleteMeetingByIdData, DeleteMeetingByIdResponse, UpdateMeetingByIdData, UpdateMeetingByIdResponse, GetMeetingsByPlannedCourseIdData, GetMeetingsByPlannedCourseIdResponse, CreateMeetingByPlannedCourseIdData, CreateMeetingByPlannedCourseIdResponse, GetPlanningMaterialsOfMeetingData, GetPlanningMaterialsOfMeetingResponse, GetPlanningMaterialsOfPlaningEventData, GetPlanningMaterialsOfPlaningEventResponse, GetPlanningMaterialsData, GetPlanningMaterialsResponse, GetOrdersData, GetOrdersResponse, CreateOrderData, CreateOrderResponse, GetOrderByIdData, GetOrderByIdResponse, ApproveOrderByIdData, ApproveOrderByIdResponse, CancelOrderByIdData, CancelOrderByIdResponse, DenyOrderByIdData, DenyOrderByIdResponse, GetPaymentMethodsData, GetPaymentMethodsResponse, GetPaymentOptionsData, GetPaymentOptionsResponse, GetTeacherEnrollmentsByPlannedCourseIdData, GetTeacherEnrollmentsByPlannedCourseIdResponse, CreateTeacherEnrollmentByPlannedCourseIdData, CreateTeacherEnrollmentByPlannedCourseIdResponse, GetTeacherEnrollmentsData, GetTeacherEnrollmentsResponse, CreateTeacherEnrollmentData, CreateTeacherEnrollmentResponse, DeleteTeacherEnrollmentByIdData, DeleteTeacherEnrollmentByIdResponse, UpdateTeacherEnrollmentByIdData, UpdateTeacherEnrollmentByIdResponse, GetPlanningConflictsData, GetPlanningConflictsResponse, GetPlanningEventsData, GetPlanningEventsResponse, CreatePlanningEventData, CreatePlanningEventResponse, GetPlanningEventByIdData, GetPlanningEventByIdResponse, DeletePlanningEventByIdData, DeletePlanningEventByIdResponse, UpdatePlanningEventByIdData, UpdatePlanningEventByIdResponse, GetPlanningLocationsData, GetPlanningLocationsResponse, GetPlanningTeachersData, GetPlanningTeachersResponse, GetProgramEditionsData, GetProgramEditionsResponse, CreateProgramEditionData, CreateProgramEditionResponse, GetProgramEditionByIdData, GetProgramEditionByIdResponse, DeleteProgramEditionByIdData, DeleteProgramEditionByIdResponse, UpdateProgramEditionByIdData, UpdateProgramEditionByIdResponse, GetProgramElementsData, GetProgramElementsResponse, CreateProgramElementData, CreateProgramElementResponse, GetProgramElementByIdData, GetProgramElementByIdResponse, DeleteProgramElementByIdData, DeleteProgramElementByIdResponse, UpdateProgramElementByIdData, UpdateProgramElementByIdResponse, GetProgramEnrollmentsData, GetProgramEnrollmentsResponse, GetProgramEnrollmentByIdData, GetProgramEnrollmentByIdResponse, AwardCertificateToProgramEnrollmentByIdData, AwardCertificateToProgramEnrollmentByIdResponse, CancelProgramEnrollmentByIdData, CancelProgramEnrollmentByIdResponse, DeleteCertificateFromProgramEnrollmentByIdData, DeleteCertificateFromProgramEnrollmentByIdResponse, GetProgramPersonalProgramElementsData, GetProgramPersonalProgramElementsResponse, GetProgramsData, GetProgramsResponse, CreateProgramData, CreateProgramResponse, GetProgramByIdData, GetProgramByIdResponse, DeleteProgramByIdData, DeleteProgramByIdResponse, UpdateProgramByIdData, UpdateProgramByIdResponse, GetReferralsData, GetReferralsResponse, CreateSignupData, CreateSignupResponse, GetSignupQuestionsData, GetSignupQuestionsResponse, GetTasksData, GetTasksResponse, CreateTaskData, CreateTaskResponse, GetTaskByIdData, GetTaskByIdResponse, DeleteTaskByIdData, DeleteTaskByIdResponse, UpdateTaskByIdData, UpdateTaskByIdResponse, GetTeacherRolesData, GetTeacherRolesResponse, CreateTeacherRoleData, CreateTeacherRoleResponse, GetTeacherRoleByIdData, GetTeacherRoleByIdResponse, DeleteTeacherRoleByIdData, DeleteTeacherRoleByIdResponse, UpdateTeacherRoleByIdData, UpdateTeacherRoleByIdResponse, GetTeachersData, GetTeachersResponse, CreateTeacherData, CreateTeacherResponse, GetTeacherByIdData, GetTeacherByIdResponse, ActivateTeacherByIdData, ActivateTeacherByIdResponse, DeactivateTeacherByIdData, DeactivateTeacherByIdResponse, GetUsersData, GetUsersResponse, CreateUserData, CreateUserResponse, GetUserByIdData, GetUserByIdResponse, UpdateUserByIdData, UpdateUserByIdResponse, GetWebhooksData, GetWebhooksResponse, CreateWebhookData, CreateWebhookResponse, GetWebhookByIdData, GetWebhookByIdResponse, DeleteWebhookByIdData, DeleteWebhookByIdResponse, UpdateWebhookByIdData, UpdateWebhookByIdResponse, GetWebhookNotificationsByWebhookIdData, GetWebhookNotificationsByWebhookIdResponse } from './types.gen';

@Injectable({
    providedIn: 'root'
})
export class AccountsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all accounts
     * @param data The data for the request.
     * @param data.search Filter results on search
     * @param data.keyContactUserId Filter results on key_contact_user_id
     * @param data.userId Filter results on user_id
     * @param data.accountType Filter results on account_type
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns AccountWithIncludes OK
     * @throws ApiError
     */
    public getAccounts(data: GetAccountsData = {}): Observable<GetAccountsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/accounts',
            query: {
                search: data.search,
                key_contact_user_id: data.keyContactUserId,
                user_id: data.userId,
                account_type: data.accountType,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create an account
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AccountWithIncludes Created
     * @throws ApiError
     */
    public createAccount(data: CreateAccountData): Observable<CreateAccountResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/accounts',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a single account
     * @param data The data for the request.
     * @param data.id
     * @returns AccountWithIncludes OK
     * @throws ApiError
     */
    public getAccountById(data: GetAccountByIdData): Observable<GetAccountByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/accounts/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class AffiliationsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all affiliations
     * @param data The data for the request.
     * @param data.userId Filter results on user_id
     * @param data.accountId Filter results on account_id
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns Affiliation OK
     * @throws ApiError
     */
    public getAffiliations(data: GetAffiliationsData = {}): Observable<GetAffiliationsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/affiliations',
            query: {
                user_id: data.userId,
                account_id: data.accountId,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create an affiliation affiliations
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Affiliation Created
     * @throws ApiError
     */
    public createAffiliation(data: CreateAffiliationData): Observable<CreateAffiliationResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/affiliations',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete an affiliation
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteAffiliationById(data: DeleteAffiliationByIdData): Observable<DeleteAffiliationByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/affiliations/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update an affiliation.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns Affiliation OK
     * @throws ApiError
     */
    public updateAffiliationById(data: UpdateAffiliationByIdData): Observable<UpdateAffiliationByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/affiliations/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class AttendancesService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all attendance records
     * @param data The data for the request.
     * @param data.meetingId Filter attendances on meeting_id
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns Attendance OK
     * @throws ApiError
     */
    public getAttendances(data: GetAttendancesData = {}): Observable<GetAttendancesResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/attendances',
            query: {
                meeting_id: data.meetingId,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Set an attendance.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Attendance OK
     * @throws ApiError
     */
    public setAttendance(data: SetAttendanceData): Observable<SetAttendanceResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/attendances/upsert',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class AuthenticationsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Create an authentication.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Authentication Created
     * @throws ApiError
     */
    public createAuthentication(data: CreateAuthenticationData): Observable<CreateAuthenticationResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/authentications',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get the authentications of an user
     * @param data The data for the request.
     * @param data.userId
     * @param data.provider Filter results on provider
     * @returns Authentication OK
     * @throws ApiError
     */
    public getAuthenticationsByUserId(data: GetAuthenticationsByUserIdData): Observable<GetAuthenticationsByUserIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/users/{user_id}/authentications',
            path: {
                user_id: data.userId
            },
            query: {
                provider: data.provider
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Remove an authentication from a user. NOTE: It is impossible to remove the last authentication for a user.
     * @param data The data for the request.
     * @param data.userId
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteAuthenticationFromUser(data: DeleteAuthenticationFromUserData): Observable<DeleteAuthenticationFromUserResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/users/{user_id}/authentications/{id}',
            path: {
                user_id: data.userId,
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class CatalogProductsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all catalog products
     * @param data The data for the request.
     * @param data.published Show only published products
     * @param data.categoryId Filter results on category_id
     * @param data.productableType Filter results on productable_type
     * @param data.search Filter results on search
     * @param data.sort Sort the results. Can change order by using `<sort_by>:<direction>` where `<direction>` is either `asc` or `desc`
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns ProductWithIncludes OK
     * @throws ApiError
     */
    public getCatalogProducts(data: GetCatalogProductsData = {}): Observable<GetCatalogProductsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/catalog/products',
            query: {
                published: data.published,
                category_id: data.categoryId,
                productable_type: data.productableType,
                search: data.search,
                sort: data.sort,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a catalog product record
     * @param data The data for the request.
     * @param data.id
     * @returns ProductWithIncludes OK
     * @throws ApiError
     */
    public getCatalogProductById(data: GetCatalogProductByIdData): Observable<GetCatalogProductByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/catalog/products/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a catalog product
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns ProductWithIncludes OK
     * @throws ApiError
     */
    public updateCatalogProductById(data: UpdateCatalogProductByIdData): Observable<UpdateCatalogProductByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/catalog/products/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class CatalogVariantsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all catalog variants
     * @param data The data for the request.
     * @param data.publishedPublic Only show published variants and planned_courses that are either planned or in progress
     * @param data.productId Filter results on product_id
     * @param data.variantableId Filter results on variantable_id
     * @param data.variantableType Filter results on variantable_type
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns VariantWithIncludes OK
     * @throws ApiError
     */
    public getCatalogVariants(data: GetCatalogVariantsData = {}): Observable<GetCatalogVariantsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/catalog/variants',
            query: {
                published_public: data.publishedPublic,
                product_id: data.productId,
                variantable_id: data.variantableId,
                variantable_type: data.variantableType,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a catalog variant record
     * @param data The data for the request.
     * @param data.id
     * @returns VariantWithIncludes OK
     * @throws ApiError
     */
    public getCatalogVariantById(data: GetCatalogVariantByIdData): Observable<GetCatalogVariantByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/catalog/variants/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a catalog variant
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns VariantWithIncludes OK
     * @throws ApiError
     */
    public updateCatalogVariantById(data: UpdateCatalogVariantByIdData): Observable<UpdateCatalogVariantByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/catalog/variants/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class CategoriesService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all category records
     * @param data The data for the request.
     * @param data.published Show only published categories
     * @param data.sort Sort the results. Can change order by using `<sort_by>:<direction>` where `<direction>` is either `asc` or `desc`
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns Category OK
     * @throws ApiError
     */
    public getCategories(data: GetCategoriesData = {}): Observable<GetCategoriesResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/categories',
            query: {
                published: data.published,
                sort: data.sort,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a category.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Category Created
     * @throws ApiError
     */
    public createCategory(data: CreateCategoryData): Observable<CreateCategoryResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/categories',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a category record
     * @param data The data for the request.
     * @param data.id
     * @returns Category OK
     * @throws ApiError
     */
    public getCategoryById(data: GetCategoryByIdData): Observable<GetCategoryByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/categories/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a category.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns Category OK
     * @throws ApiError
     */
    public updateCategoryById(data: UpdateCategoryByIdData): Observable<UpdateCategoryByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/categories/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class CommentsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Create a comment.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Comment Created
     * @throws ApiError
     */
    public createComment(data: CreateCommentData): Observable<CreateCommentResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/comments',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a comment.
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteCommentById(data: DeleteCommentByIdData): Observable<DeleteCommentByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/comments/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a comment.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns Comment OK
     * @throws ApiError
     */
    public updateCommentById(data: UpdateCommentByIdData): Observable<UpdateCommentByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/comments/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class CourseLocationsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all course location records
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns CourseLocationWithIncludes OK
     * @throws ApiError
     */
    public getCourseLocations(data: GetCourseLocationsData = {}): Observable<GetCourseLocationsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/course_locations',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a course location.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns CourseLocationWithIncludes Created
     * @throws ApiError
     */
    public createCourseLocation(data: CreateCourseLocationData): Observable<CreateCourseLocationResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/course_locations',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a course location record
     * @param data The data for the request.
     * @param data.id
     * @returns CourseLocationWithIncludes OK
     * @throws ApiError
     */
    public getCourseLocationById(data: GetCourseLocationByIdData): Observable<GetCourseLocationByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/course_locations/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a course location.
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteCourseLocationById(data: DeleteCourseLocationByIdData): Observable<DeleteCourseLocationByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/course_locations/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a course location.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns CourseLocationWithIncludes OK
     * @throws ApiError
     */
    public updateCourseLocationById(data: UpdateCourseLocationByIdData): Observable<UpdateCourseLocationByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/course_locations/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class CourseTabsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all course tab records
     * @returns CourseTab OK
     * @throws ApiError
     */
    public getCourseTabs(): Observable<GetCourseTabsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/course_tabs',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class CourseVariantsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all course variant records
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns CourseVariant OK
     * @throws ApiError
     */
    public getCourseVariants(data: GetCourseVariantsData = {}): Observable<GetCourseVariantsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/course_variants',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a course variant
     * @param data The data for the request.
     * @param data.requestBody
     * @returns CourseVariant Created
     * @throws ApiError
     */
    public createCourseVariant(data: CreateCourseVariantData): Observable<CreateCourseVariantResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/course_variants',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a course variant record
     * @param data The data for the request.
     * @param data.id
     * @returns CourseVariant OK
     * @throws ApiError
     */
    public getCourseVariantById(data: GetCourseVariantByIdData): Observable<GetCourseVariantByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/course_variants/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class CoursesService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all course records
     * @param data The data for the request.
     * @param data.published Show only published courses
     * @param data.id Filter results on id
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns CourseWithIncludes OK
     * @throws ApiError
     */
    public getCourses(data: GetCoursesData = {}): Observable<GetCoursesResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/courses',
            query: {
                published: data.published,
                id: data.id,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a course.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns CourseWithIncludes Created
     * @throws ApiError
     */
    public createCourse(data: CreateCourseData): Observable<CreateCourseResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/courses',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a course record
     * @param data The data for the request.
     * @param data.id
     * @returns CourseWithIncludes OK
     * @throws ApiError
     */
    public getCourseById(data: GetCourseByIdData): Observable<GetCourseByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/courses/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a course.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns CourseWithIncludes OK
     * @throws ApiError
     */
    public updateCourseById(data: UpdateCourseByIdData): Observable<UpdateCourseByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/courses/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class PlannedCoursesService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all planned course records of a single course
     * @param data The data for the request.
     * @param data.courseId
     * @param data.search Filter results on search
     * @param data.type Filter results on type
     * @param data.parentsPublished Filter results on parents_published
     * @param data.publishedPublic Only show courses that are published and are either planned or in progress
     * @param data.startDateFrom Filter results on start_date_from
     * @param data.startDateUntil Filter results on start_date_until
     * @param data.availabilityState Filter results on availability_state
     * @param data.id Filter results on id
     * @param data.status Filter results on status
     * @param data.sort Sort the results. Can change order by using `<sort_by>:<direction>` where `<direction>` is either `asc` or `desc`
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns PlannedCourseWithIncludes OK
     * @throws ApiError
     */
    public getPlannedCoursesByCourseId(data: GetPlannedCoursesByCourseIdData): Observable<GetPlannedCoursesByCourseIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/courses/{course_id}/planned_courses',
            path: {
                course_id: data.courseId
            },
            query: {
                search: data.search,
                type: data.type,
                parents_published: data.parentsPublished,
                published_public: data.publishedPublic,
                start_date_from: data.startDateFrom,
                start_date_until: data.startDateUntil,
                availability_state: data.availabilityState,
                id: data.id,
                status: data.status,
                sort: data.sort,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a planned course record of a single course
     * @param data The data for the request.
     * @param data.id
     * @param data.courseId
     * @returns PlannedCourseWithIncludes OK
     * @throws ApiError
     */
    public getPlannedCoursesByIdAndCourseId(data: GetPlannedCoursesByIdAndCourseIdData): Observable<GetPlannedCoursesByIdAndCourseIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/courses/{course_id}/planned_courses/{id}',
            path: {
                id: data.id,
                course_id: data.courseId
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get all planned course records
     * @param data The data for the request.
     * @param data.search Filter results on search
     * @param data.type Filter results on type
     * @param data.parentsPublished Filter results on parents_published
     * @param data.publishedPublic Only show courses that are published and are either planned or in progress
     * @param data.startDateFrom Filter results on start_date_from
     * @param data.startDateUntil Filter results on start_date_until
     * @param data.availabilityState Filter results on availability_state
     * @param data.id Filter results on id
     * @param data.courseId Filter results on course_id
     * @param data.status Filter results on status
     * @param data.sort Sort the results. Can change order by using `<sort_by>:<direction>` where `<direction>` is either `asc` or `desc`
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns PlannedCourseWithIncludes OK
     * @throws ApiError
     */
    public getPlannedCourses(data: GetPlannedCoursesData = {}): Observable<GetPlannedCoursesResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/planned_courses',
            query: {
                search: data.search,
                type: data.type,
                parents_published: data.parentsPublished,
                published_public: data.publishedPublic,
                start_date_from: data.startDateFrom,
                start_date_until: data.startDateUntil,
                availability_state: data.availabilityState,
                id: data.id,
                course_id: data.courseId,
                status: data.status,
                sort: data.sort,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a planned course.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns PlannedCourseWithIncludes Created
     * @throws ApiError
     */
    public createPlannedCourse(data: CreatePlannedCourseData): Observable<CreatePlannedCourseResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/planned_courses',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a planned course record
     * @param data The data for the request.
     * @param data.id
     * @returns PlannedCourseWithIncludes OK
     * @throws ApiError
     */
    public getPlannedCourseById(data: GetPlannedCourseByIdData): Observable<GetPlannedCourseByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/planned_courses/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a planned course.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns PlannedCourseWithIncludes OK
     * @throws ApiError
     */
    public updatePlannedCourseById(data: UpdatePlannedCourseByIdData): Observable<UpdatePlannedCourseByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/planned_courses/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Cancel a planned course.
     * @param data The data for the request.
     * @param data.id
     * @returns PlannedCourseWithIncludes OK
     * @throws ApiError
     */
    public cancelPlannedCourseById(data: CancelPlannedCourseByIdData): Observable<CancelPlannedCourseByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/planned_courses/{id}/cancel',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class CreditCategoriesService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all credit category records
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns CreditCategoryWithIncludes OK
     * @throws ApiError
     */
    public getCreditCategories(data: GetCreditCategoriesData = {}): Observable<GetCreditCategoriesResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/credit_categories',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class CreditsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all credit records
     * @param data The data for the request.
     * @param data.studentId Filter results on student_id
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns Credit OK
     * @throws ApiError
     */
    public getCredits(data: GetCreditsData = {}): Observable<GetCreditsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/credits',
            query: {
                student_id: data.studentId,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class EducatorsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get an educator record
     * @returns EducatorWithIncludes OK
     * @throws ApiError
     */
    public getCurrentEducator(): Observable<GetCurrentEducatorResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/educators/current',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                412: 'Precondition Failed',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class EnrollmentsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all enrollment records
     * @param data The data for the request.
     * @param data.studentId Filter results on student_id
     * @param data.plannedCourseId Filter results on planned_course_id
     * @param data.status Filter results on status
     * @param data.withCanceled Filter results based on whether they include a canceled status or not
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns EnrollmentWithIncludes OK
     * @throws ApiError
     */
    public getEnrollments(data: GetEnrollmentsData = {}): Observable<GetEnrollmentsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/enrollments',
            query: {
                student_id: data.studentId,
                planned_course_id: data.plannedCourseId,
                status: data.status,
                with_canceled: data.withCanceled,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get an enrollment record
     * @param data The data for the request.
     * @param data.id
     * @returns EnrollmentWithIncludes OK
     * @throws ApiError
     */
    public getEnrollmentById(data: GetEnrollmentByIdData): Observable<GetEnrollmentByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/enrollments/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update an enrollment
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns EnrollmentWithIncludes OK
     * @throws ApiError
     */
    public updateEnrollmentById(data: UpdateEnrollmentByIdData): Observable<UpdateEnrollmentByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/enrollments/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Cancel an enrollment
     * @param data The data for the request.
     * @param data.id
     * @returns EnrollmentWithIncludes OK
     * @throws ApiError
     */
    public cancelEnrollmentById(data: CancelEnrollmentByIdData): Observable<CancelEnrollmentByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/enrollments/{id}/cancel',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class GradesService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Create a grade
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Grade Created
     * @throws ApiError
     */
    public createGrade(data: CreateGradeData): Observable<CreateGradeResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/grades',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a grade record
     * @param data The data for the request.
     * @param data.id
     * @returns Grade OK
     * @throws ApiError
     */
    public getGradeById(data: GetGradeByIdData): Observable<GetGradeByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/grades/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a grade.
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteGradeById(data: DeleteGradeByIdData): Observable<DeleteGradeByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/grades/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a grade
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns Grade OK
     * @throws ApiError
     */
    public updateGradeById(data: UpdateGradeByIdData): Observable<UpdateGradeByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/grades/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class InvoiceVatsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all invoice vat records
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns InvoiceVatWithIncludes OK
     * @throws ApiError
     */
    public getInvoiceVats(data: GetInvoiceVatsData = {}): Observable<GetInvoiceVatsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/invoice_vats',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create an invoice vat.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns InvoiceVatWithIncludes Created
     * @throws ApiError
     */
    public createInvoiceVat(data: CreateInvoiceVatData): Observable<CreateInvoiceVatResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/invoice_vats',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class InvoicesService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all invoice records
     * @param data The data for the request.
     * @param data.accountId Filter results on account_id
     * @param data.status Filter results on status
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns InvoiceWithIncludes OK
     * @throws ApiError
     */
    public getInvoices(data: GetInvoicesData = {}): Observable<GetInvoicesResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/invoices',
            query: {
                account_id: data.accountId,
                status: data.status,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create an invoice.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns InvoiceWithIncludes Created
     * @throws ApiError
     */
    public createInvoice(data: CreateInvoiceData): Observable<CreateInvoiceResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/invoices',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get an invoice record
     * @param data The data for the request.
     * @param data.id
     * @returns InvoiceWithIncludes OK
     * @throws ApiError
     */
    public getInvoiceById(data: GetInvoiceByIdData): Observable<GetInvoiceByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/invoices/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Changes the state from concept to open.
     * This will assign the actual invoice number so it's ready for sending.
     * If the current state is not concept, this endpoint does nothing.
     *
     * @param data The data for the request.
     * @param data.id
     * @returns InvoiceWithIncludes OK
     * @throws ApiError
     */
    public openInvoiceById(data: OpenInvoiceByIdData): Observable<OpenInvoiceByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/invoices/{id}/open',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get the base64 encoded version of the invoice PDF
     * @param data The data for the request.
     * @param data.id
     * @returns unknown OK
     * @throws ApiError
     */
    public getInvoicePdfById(data: GetInvoicePdfByIdData): Observable<GetInvoicePdfByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/invoices/{id}/pdf',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class PaymentsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all payment records of an invoice
     * @param data The data for the request.
     * @param data.invoiceId Filter results on invoice_id
     * @returns PaymentWithIncludes OK
     * @throws ApiError
     */
    public getInvoicePaymentsByInvoiceId(data: GetInvoicePaymentsByInvoiceIdData): Observable<GetInvoicePaymentsByInvoiceIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/invoices/{invoice_id}/payments',
            path: {
                invoice_id: data.invoiceId
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a payment.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.invoiceId Filter results on invoice_id
     * @returns PaymentWithFixedIncludes Created
     * @throws ApiError
     */
    public createInvoicePaymentByInvoiceId(data: CreateInvoicePaymentByInvoiceIdData): Observable<CreateInvoicePaymentByInvoiceIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/invoices/{invoice_id}/payments',
            path: {
                invoice_id: data.invoiceId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a payment.
     * @param data The data for the request.
     * @param data.id
     * @param data.invoiceId
     * @returns void No Content
     * @throws ApiError
     */
    public deleteInvoicePaymentByIdAndInvoiceId(data: DeleteInvoicePaymentByIdAndInvoiceIdData): Observable<DeleteInvoicePaymentByIdAndInvoiceIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/invoices/{invoice_id}/payments/{id}',
            path: {
                id: data.id,
                invoice_id: data.invoiceId
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get one payment record
     * @param data The data for the request.
     * @param data.id
     * @returns PaymentWithIncludes OK
     * @throws ApiError
     */
    public getPaymentById(data: GetPaymentByIdData): Observable<GetPaymentByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/payments/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class LabelsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all labels
     * @param data The data for the request.
     * @param data.modelType Filter results on model_type
     * @param data.search Filter results on search
     * @param data.id Filter results on id
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns Label OK
     * @throws ApiError
     */
    public getLabels(data: GetLabelsData = {}): Observable<GetLabelsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/labels',
            query: {
                model_type: data.modelType,
                search: data.search,
                id: data.id,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a label
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Label Created
     * @throws ApiError
     */
    public createLabel(data: CreateLabelData): Observable<CreateLabelResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/labels',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a label
     * @param data The data for the request.
     * @param data.id
     * @returns Label OK
     * @throws ApiError
     */
    public getLabelById(data: GetLabelByIdData): Observable<GetLabelByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/labels/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a label
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteLabelById(data: DeleteLabelByIdData): Observable<DeleteLabelByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/labels/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a label
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns Label OK
     * @throws ApiError
     */
    public updateLabelById(data: UpdateLabelByIdData): Observable<UpdateLabelByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/labels/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Add label to an order
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public addLabelToOrder(data: AddLabelToOrderData): Observable<AddLabelToOrderResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/orders/{id}/labels',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class LeadsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all lead records
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns LeadWithIncludes OK
     * @throws ApiError
     */
    public getLeads(data: GetLeadsData = {}): Observable<GetLeadsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/leads',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a lead.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Error OK
     * @returns LeadWithIncludes Created
     * @throws ApiError
     */
    public createLead(data: CreateLeadData): Observable<CreateLeadResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/leads',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get one lead record
     * @param data The data for the request.
     * @param data.id
     * @returns LeadWithIncludes OK
     * @throws ApiError
     */
    public getLeadById(data: GetLeadByIdData): Observable<GetLeadByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/leads/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a lead.
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteLeadById(data: DeleteLeadByIdData): Observable<DeleteLeadByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/leads/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class MaterialGroupsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all material group records
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns MaterialGroup OK
     * @throws ApiError
     */
    public getMaterialGroups(data: GetMaterialGroupsData = {}): Observable<GetMaterialGroupsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/material_groups',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a material group.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns MaterialGroup Created
     * @throws ApiError
     */
    public createMaterialGroup(data: CreateMaterialGroupData): Observable<CreateMaterialGroupResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/material_groups',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a material group record
     * @param data The data for the request.
     * @param data.id
     * @returns MaterialGroup OK
     * @throws ApiError
     */
    public getMaterialGroupById(data: GetMaterialGroupByIdData): Observable<GetMaterialGroupByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/material_groups/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a material group.
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteMaterialGroupById(data: DeleteMaterialGroupByIdData): Observable<DeleteMaterialGroupByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/material_groups/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a material group.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns MaterialGroup OK
     * @throws ApiError
     */
    public updateMaterialGroupById(data: UpdateMaterialGroupByIdData): Observable<UpdateMaterialGroupByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/material_groups/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class MaterialsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all material records
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns MaterialWithIncludes OK
     * @throws ApiError
     */
    public getMaterials(data: GetMaterialsData = {}): Observable<GetMaterialsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/materials',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a material.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns MaterialWithIncludes Created
     * @throws ApiError
     */
    public createMaterial(data: CreateMaterialData): Observable<CreateMaterialResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/materials',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a material.
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteMaterialById(data: DeleteMaterialByIdData): Observable<DeleteMaterialByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/materials/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a material.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns MaterialWithIncludes OK
     * @throws ApiError
     */
    public updateMaterialById(data: UpdateMaterialByIdData): Observable<UpdateMaterialByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/materials/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class MeetingLocationsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all meeting location records
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns MeetingLocationWithIncludes OK
     * @throws ApiError
     */
    public getMeetingLocations(data: GetMeetingLocationsData = {}): Observable<GetMeetingLocationsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/meeting_locations',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a meeting location.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns MeetingLocationWithIncludes Created
     * @throws ApiError
     */
    public createMeetingLocation(data: CreateMeetingLocationData): Observable<CreateMeetingLocationResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/meeting_locations',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get an meeting location
     * @param data The data for the request.
     * @param data.id
     * @returns MeetingLocationWithIncludes OK
     * @throws ApiError
     */
    public getMeetingLocationById(data: GetMeetingLocationByIdData): Observable<GetMeetingLocationByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/meeting_locations/{id}',
            path: {
                id: data.id
            },
            errors: {
                401: 'Unauthorized',
                404: 'Not Found'
            }
        });
    }
    
    /**
     * Delete a course location.
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteMeetingLocationById(data: DeleteMeetingLocationByIdData): Observable<DeleteMeetingLocationByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/meeting_locations/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a meeting location.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns MeetingLocationWithIncludes OK
     * @throws ApiError
     */
    public updateMeetingLocationById(data: UpdateMeetingLocationByIdData): Observable<UpdateMeetingLocationByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/meeting_locations/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class MeetingsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all meeting records
     * @param data The data for the request.
     * @param data.plannedCourseId Filter results on planned_course_id
     * @param data.forStudentId Filter results on for_student_id
     * @param data.dateFrom Filter results on date_from
     * @param data.start Only show meetings ending after this date and time
     * @param data.end Only show meetings starting before this date and time
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.cursor The cursor used to fetch the next result set. **Note**: It's almost never necessary to use this parameter directly, the URL
     * should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns MeetingWithIncludes OK
     * @throws ApiError
     */
    public getMeetings(data: GetMeetingsData = {}): Observable<GetMeetingsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/meetings',
            query: {
                planned_course_id: data.plannedCourseId,
                for_student_id: data.forStudentId,
                date_from: data.dateFrom,
                start: data.start,
                end: data.end,
                page: data.page,
                cursor: data.cursor,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a meeting.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns MeetingWithIncludes Created
     * @throws ApiError
     */
    public createMeeting(data: CreateMeetingData): Observable<CreateMeetingResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/meetings',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get an meeting record
     * @param data The data for the request.
     * @param data.id
     * @returns MeetingWithIncludes OK
     * @throws ApiError
     */
    public getMeetingById(data: GetMeetingByIdData): Observable<GetMeetingByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/meetings/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a meeting.
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteMeetingById(data: DeleteMeetingByIdData): Observable<DeleteMeetingByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/meetings/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a meeting.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns MeetingWithIncludes OK
     * @throws ApiError
     */
    public updateMeetingById(data: UpdateMeetingByIdData): Observable<UpdateMeetingByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/meetings/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get all meeting records of a planned course
     * @param data The data for the request.
     * @param data.plannedCourseId Filter results on planned_course_id
     * @param data.forStudentId Filter results on for_student_id
     * @param data.dateFrom Filter results on date_from
     * @param data.sort Sort the results. Can change order by using `<sort_by>:<direction>` where `<direction>` is either `asc` or `desc`
     * @returns MeetingWithIncludes OK
     * @throws ApiError
     */
    public getMeetingsByPlannedCourseId(data: GetMeetingsByPlannedCourseIdData): Observable<GetMeetingsByPlannedCourseIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/planned_courses/{planned_course_id}/meetings',
            path: {
                planned_course_id: data.plannedCourseId
            },
            query: {
                for_student_id: data.forStudentId,
                date_from: data.dateFrom,
                sort: data.sort
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a meeting within a planned course.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.plannedCourseId Filter results on planned_course_id
     * @returns MeetingWithIncludes Created
     * @throws ApiError
     */
    public createMeetingByPlannedCourseId(data: CreateMeetingByPlannedCourseIdData): Observable<CreateMeetingByPlannedCourseIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/planned_courses/{planned_course_id}/meetings',
            path: {
                planned_course_id: data.plannedCourseId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class PlanningMaterialsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all planning materials of a meeting
     * @param data The data for the request.
     * @param data.id
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns PlanningMaterial OK
     * @throws ApiError
     */
    public getPlanningMaterialsOfMeeting(data: GetPlanningMaterialsOfMeetingData): Observable<GetPlanningMaterialsOfMeetingResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/meetings/{id}/materials',
            path: {
                id: data.id
            },
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get all planning materials of a planning event
     * @param data The data for the request.
     * @param data.id
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns PlanningMaterial OK
     * @throws ApiError
     */
    public getPlanningMaterialsOfPlaningEvent(data: GetPlanningMaterialsOfPlaningEventData): Observable<GetPlanningMaterialsOfPlaningEventResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/planning/events/{id}/materials',
            path: {
                id: data.id
            },
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get all materials that are available
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns Material OK
     * @throws ApiError
     */
    public getPlanningMaterials(data: GetPlanningMaterialsData = {}): Observable<GetPlanningMaterialsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/planning/materials',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class OrdersService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all order records
     * @param data The data for the request.
     * @param data.creatorId Filter results on creator_id
     * @param data.createdAtAfter Filter results on created_at_after
     * @param data.courseId Filter results on course_id
     * @param data.sort Sort the results. Can change order by using `<sort_by>:<direction>` where `<direction>` is either `asc` or `desc`
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns OrderWithIncludes OK
     * @throws ApiError
     */
    public getOrders(data: GetOrdersData = {}): Observable<GetOrdersResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/orders',
            query: {
                creator_id: data.creatorId,
                created_at_after: data.createdAtAfter,
                course_id: data.courseId,
                sort: data.sort,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create an order.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Error OK
     * @returns OrderWithIncludes Created
     * @throws ApiError
     */
    public createOrder(data: CreateOrderData): Observable<CreateOrderResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/orders',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get an order record
     * @param data The data for the request.
     * @param data.id
     * @returns OrderWithIncludes OK
     * @throws ApiError
     */
    public getOrderById(data: GetOrderByIdData): Observable<GetOrderByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/orders/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Approve an order
     * @param data The data for the request.
     * @param data.id
     * @returns OrderWithIncludes OK
     * @throws ApiError
     */
    public approveOrderById(data: ApproveOrderByIdData): Observable<ApproveOrderByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/orders/{id}/approve',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Cancel an order
     * @param data The data for the request.
     * @param data.id
     * @returns OrderWithIncludes OK
     * @throws ApiError
     */
    public cancelOrderById(data: CancelOrderByIdData): Observable<CancelOrderByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/orders/{id}/cancel',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Deny an order
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public denyOrderById(data: DenyOrderByIdData): Observable<DenyOrderByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/orders/{id}/deny',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class PaymentMethodsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all payment method records available for customers
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns PaymentMethod OK
     * @throws ApiError
     */
    public getPaymentMethods(data: GetPaymentMethodsData = {}): Observable<GetPaymentMethodsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/payment_methods',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class PaymentOptionsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all payment option records
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns PaymentOption OK
     * @throws ApiError
     */
    public getPaymentOptions(data: GetPaymentOptionsData = {}): Observable<GetPaymentOptionsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/payment_options',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class TeacherEnrollmentsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all teacher enrollments for given planned course.
     * @param data The data for the request.
     * @param data.plannedCourseId Filter results on planned_course_id
     * @returns TeacherEnrollment OK
     * @throws ApiError
     */
    public getTeacherEnrollmentsByPlannedCourseId(data: GetTeacherEnrollmentsByPlannedCourseIdData): Observable<GetTeacherEnrollmentsByPlannedCourseIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/planned_courses/{planned_course_id}/teacher_enrollments',
            path: {
                planned_course_id: data.plannedCourseId
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Enroll a teacher to the given planned course.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.plannedCourseId Filter results on planned_course_id
     * @returns TeacherEnrollment Created
     * @throws ApiError
     */
    public createTeacherEnrollmentByPlannedCourseId(data: CreateTeacherEnrollmentByPlannedCourseIdData): Observable<CreateTeacherEnrollmentByPlannedCourseIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/planned_courses/{planned_course_id}/teacher_enrollments',
            path: {
                planned_course_id: data.plannedCourseId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get all teacher enrollments.
     * @param data The data for the request.
     * @param data.plannedCourseId Filter results on planned_course_id
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns TeacherEnrollment OK
     * @throws ApiError
     */
    public getTeacherEnrollments(data: GetTeacherEnrollmentsData = {}): Observable<GetTeacherEnrollmentsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/teacher_enrollments',
            query: {
                planned_course_id: data.plannedCourseId,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Enroll a teacher to a planned_course.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TeacherEnrollment Created
     * @throws ApiError
     */
    public createTeacherEnrollment(data: CreateTeacherEnrollmentData): Observable<CreateTeacherEnrollmentResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/teacher_enrollments',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a teacher enrollment.
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteTeacherEnrollmentById(data: DeleteTeacherEnrollmentByIdData): Observable<DeleteTeacherEnrollmentByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/teacher_enrollments/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a teacher enrollment.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns TeacherEnrollment OK
     * @throws ApiError
     */
    public updateTeacherEnrollmentById(data: UpdateTeacherEnrollmentByIdData): Observable<UpdateTeacherEnrollmentByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/teacher_enrollments/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class PlanningConflictsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all conflicts
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns PlanningConflict OK
     * @throws ApiError
     */
    public getPlanningConflicts(data: GetPlanningConflictsData = {}): Observable<GetPlanningConflictsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/planning/conflicts',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class PlanningEventsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all planning event records
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns PlanningEventWithIncludes OK
     * @throws ApiError
     */
    public getPlanningEvents(data: GetPlanningEventsData = {}): Observable<GetPlanningEventsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/planning/events',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a planning event
     * @param data The data for the request.
     * @param data.requestBody
     * @returns PlanningEventWithIncludes Created
     * @throws ApiError
     */
    public createPlanningEvent(data: CreatePlanningEventData): Observable<CreatePlanningEventResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/planning/events',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get an planning event record
     * @param data The data for the request.
     * @param data.id
     * @returns PlanningEventWithIncludes OK
     * @throws ApiError
     */
    public getPlanningEventById(data: GetPlanningEventByIdData): Observable<GetPlanningEventByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/planning/events/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a planning event.
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deletePlanningEventById(data: DeletePlanningEventByIdData): Observable<DeletePlanningEventByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/planning/events/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update an planning event.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns PlanningEventWithIncludes OK
     * @throws ApiError
     */
    public updatePlanningEventById(data: UpdatePlanningEventByIdData): Observable<UpdatePlanningEventByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/planning/events/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class PlanningLocationsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all locations that are available
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns MeetingLocation OK
     * @throws ApiError
     */
    public getPlanningLocations(data: GetPlanningLocationsData = {}): Observable<GetPlanningLocationsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/planning/locations',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class PlanningTeachersService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all teachers that are available
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns User OK
     * @throws ApiError
     */
    public getPlanningTeachers(data: GetPlanningTeachersData = {}): Observable<GetPlanningTeachersResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/planning/teachers',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class ProgramEditionsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all program editions
     * @param data The data for the request.
     * @param data.programId Filter results on program_id
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns EditionWithIncludes OK
     * @throws ApiError
     */
    public getProgramEditions(data: GetProgramEditionsData = {}): Observable<GetProgramEditionsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/program/editions',
            query: {
                program_id: data.programId,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a program edition
     * @param data The data for the request.
     * @param data.requestBody
     * @returns EditionWithIncludes Created
     * @throws ApiError
     */
    public createProgramEdition(data: CreateProgramEditionData): Observable<CreateProgramEditionResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/program/editions',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a program edition
     * @param data The data for the request.
     * @param data.id
     * @returns EditionWithIncludes OK
     * @throws ApiError
     */
    public getProgramEditionById(data: GetProgramEditionByIdData): Observable<GetProgramEditionByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/program/editions/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a program edition
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteProgramEditionById(data: DeleteProgramEditionByIdData): Observable<DeleteProgramEditionByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/program/editions/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a program edition
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns EditionWithIncludes OK
     * @throws ApiError
     */
    public updateProgramEditionById(data: UpdateProgramEditionByIdData): Observable<UpdateProgramEditionByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/program/editions/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class ProgramElementsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all elements
     * This endpoint will only return elements of type 'Course Element' that are directly linked to the program edition(s). It does not consider possible blocks.
     * @param data The data for the request.
     * @param data.editionId Filter results on edition_id
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns Element OK
     * @throws ApiError
     */
    public getProgramElements(data: GetProgramElementsData = {}): Observable<GetProgramElementsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/program/elements',
            query: {
                edition_id: data.editionId,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a program element
     * This endpoint can only create elements of type 'Course Element' that are directly linked to the program edition(s). It does not consider possible blocks.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Element Created
     * @throws ApiError
     */
    public createProgramElement(data: CreateProgramElementData): Observable<CreateProgramElementResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/program/elements',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get an element
     * This endpoint will only return elements of type 'Course Element' that are directly linked to the program edition(s). It does not consider possible blocks.
     * @param data The data for the request.
     * @param data.id
     * @returns Element OK
     * @throws ApiError
     */
    public getProgramElementById(data: GetProgramElementByIdData): Observable<GetProgramElementByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/program/elements/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a element
     * This endpoint can only remove elements of type 'Course Element' that are directly linked to the program edition(s). It does not consider possible blocks.
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteProgramElementById(data: DeleteProgramElementByIdData): Observable<DeleteProgramElementByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/program/elements/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update an element
     * This endpoint can only change elements of type 'Course Element' that are directly linked to the program edition(s). It does not consider possible blocks.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns Element OK
     * @throws ApiError
     */
    public updateProgramElementById(data: UpdateProgramElementByIdData): Observable<UpdateProgramElementByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/program/elements/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class ProgramEnrollmentsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all program enrollments
     * @param data The data for the request.
     * @param data.studentId Filter results on student_id
     * @param data.editionId Filter results on edition_id
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns ProgramEnrollmentWithIncludes OK
     * @throws ApiError
     */
    public getProgramEnrollments(data: GetProgramEnrollmentsData = {}): Observable<GetProgramEnrollmentsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/program/enrollments',
            query: {
                student_id: data.studentId,
                edition_id: data.editionId,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a program enrollment record
     * @param data The data for the request.
     * @param data.id
     * @returns ProgramEnrollmentWithIncludes OK
     * @throws ApiError
     */
    public getProgramEnrollmentById(data: GetProgramEnrollmentByIdData): Observable<GetProgramEnrollmentByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/program/enrollments/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Awards a certificate to a program enrollment
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns ProgramEnrollmentWithIncludes OK
     * @throws ApiError
     */
    public awardCertificateToProgramEnrollmentById(data: AwardCertificateToProgramEnrollmentByIdData): Observable<AwardCertificateToProgramEnrollmentByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/program/enrollments/{id}/award_certificate',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Cancel a program enrollment
     * @param data The data for the request.
     * @param data.id
     * @returns ProgramEnrollmentWithIncludes OK
     * @throws ApiError
     */
    public cancelProgramEnrollmentById(data: CancelProgramEnrollmentByIdData): Observable<CancelProgramEnrollmentByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/program/enrollments/{id}/cancel',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Deletes a certificate from a program enrollment
     * @param data The data for the request.
     * @param data.id
     * @returns ProgramEnrollmentWithIncludes OK
     * @throws ApiError
     */
    public deleteCertificateFromProgramEnrollmentById(data: DeleteCertificateFromProgramEnrollmentByIdData): Observable<DeleteCertificateFromProgramEnrollmentByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/program/enrollments/{id}/delete_certificate',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class ProgramPersonalProgramElementsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * @deprecated
     * Get all program personal program elements
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns PersonalProgramElement OK
     * @throws ApiError
     */
    public getProgramPersonalProgramElements(data: GetProgramPersonalProgramElementsData = {}): Observable<GetProgramPersonalProgramElementsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/program/personal_program_elements',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                409: 'Conflict',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class ProgramProgramsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all programs
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns ProgramWithIncludes OK
     * @throws ApiError
     */
    public getPrograms(data: GetProgramsData = {}): Observable<GetProgramsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/program/programs',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a program
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ProgramWithIncludes Created
     * @throws ApiError
     */
    public createProgram(data: CreateProgramData): Observable<CreateProgramResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/program/programs',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a program
     * @param data The data for the request.
     * @param data.id
     * @returns ProgramWithIncludes OK
     * @throws ApiError
     */
    public getProgramById(data: GetProgramByIdData): Observable<GetProgramByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/program/programs/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a program
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteProgramById(data: DeleteProgramByIdData): Observable<DeleteProgramByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/program/programs/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a program
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns ProgramWithIncludes OK
     * @throws ApiError
     */
    public updateProgramById(data: UpdateProgramByIdData): Observable<UpdateProgramByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/program/programs/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class ReferralsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all referral records
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns Referral OK
     * @throws ApiError
     */
    public getReferrals(data: GetReferralsData = {}): Observable<GetReferralsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/referrals',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class SignupService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Perform a signup.
     *
     * <p>Often you want to redirect the user after a successfull signup. The expected redirect url is returned in the <code>Location</code> header (just as normal 302 redirects). If the user wants to pay with a payment provider, this is also the URL to the payment URL.</p>
     *
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Error OK
     * @returns OrderWithIncludes Created
     * @throws ApiError
     */
    public createSignup(data: CreateSignupData): Observable<CreateSignupResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/signup',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class SignupQuestionsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all signup_question records
     * @param data The data for the request.
     * @param data.forUser Filter results on for_user
     * @param data.forAccount Filter results on for_account
     * @param data.forType Filter results on for_type
     * @param data.visibility Filter results on visibility
     * @param data.useAsDuplicateIndicator Filter results on use_as_duplicate_indicator
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns SignupQuestion OK
     * @throws ApiError
     */
    public getSignupQuestions(data: GetSignupQuestionsData = {}): Observable<GetSignupQuestionsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/signup_questions',
            query: {
                for_user: data.forUser,
                for_account: data.forAccount,
                for_type: data.forType,
                visibility: data.visibility,
                use_as_duplicate_indicator: data.useAsDuplicateIndicator,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class TasksService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all task records
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns Task OK
     * @throws ApiError
     */
    public getTasks(data: GetTasksData = {}): Observable<GetTasksResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/tasks',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a task.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Task Created
     * @throws ApiError
     */
    public createTask(data: CreateTaskData): Observable<CreateTaskResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/tasks',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a task record
     * @param data The data for the request.
     * @param data.id
     * @returns Task OK
     * @throws ApiError
     */
    public getTaskById(data: GetTaskByIdData): Observable<GetTaskByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/tasks/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a task.
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteTaskById(data: DeleteTaskByIdData): Observable<DeleteTaskByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/tasks/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a task.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns Task OK
     * @throws ApiError
     */
    public updateTaskById(data: UpdateTaskByIdData): Observable<UpdateTaskByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/tasks/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class TeacherRolesService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all teacher roles
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns TeacherRole OK
     * @throws ApiError
     */
    public getTeacherRoles(data: GetTeacherRolesData = {}): Observable<GetTeacherRolesResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/teacher_roles',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a teacher role.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TeacherRole Created
     * @throws ApiError
     */
    public createTeacherRole(data: CreateTeacherRoleData): Observable<CreateTeacherRoleResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/teacher_roles',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a teacher role
     * @param data The data for the request.
     * @param data.id
     * @returns TeacherRole OK
     * @throws ApiError
     */
    public getTeacherRoleById(data: GetTeacherRoleByIdData): Observable<GetTeacherRoleByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/teacher_roles/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a teacher role.
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deleteTeacherRoleById(data: DeleteTeacherRoleByIdData): Observable<DeleteTeacherRoleByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/teacher_roles/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a teacher role.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns TeacherRole OK
     * @throws ApiError
     */
    public updateTeacherRoleById(data: UpdateTeacherRoleByIdData): Observable<UpdateTeacherRoleByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/teacher_roles/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class TeachersService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all teacher records
     * @param data The data for the request.
     * @param data.search Filter results on search
     * @param data.labelId Filter results on label_id
     * @param data.id Filter results on id
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns TeacherWithIncludes OK
     * @throws ApiError
     */
    public getTeachers(data: GetTeachersData = {}): Observable<GetTeachersResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/teachers',
            query: {
                search: data.search,
                label_id: data.labelId,
                id: data.id,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a new teacher
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Created
     * @throws ApiError
     */
    public createTeacher(data: CreateTeacherData): Observable<CreateTeacherResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/teachers',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a teacher record
     * @param data The data for the request.
     * @param data.id
     * @returns TeacherWithIncludes OK
     * @throws ApiError
     */
    public getTeacherById(data: GetTeacherByIdData): Observable<GetTeacherByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/teachers/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Mark teacher as active
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public activateTeacherById(data: ActivateTeacherByIdData): Observable<ActivateTeacherByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/teachers/{id}/activate',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Mark teacher as inactive
     * @param data The data for the request.
     * @param data.id
     * @returns void No Content
     * @throws ApiError
     */
    public deactivateTeacherById(data: DeactivateTeacherByIdData): Observable<DeactivateTeacherByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/teachers/{id}/deactivate',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class UsersService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all user records
     * @param data The data for the request.
     * @param data.role Filter results on role
     * @param data.email Filter results on email
     * @param data.labelId Filter results on label_id
     * @param data.sort Sort the results. Can change order by using `<sort_by>:<direction>` where `<direction>` is either `asc` or `desc`
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns UserWithIncludes OK
     * @throws ApiError
     */
    public getUsers(data: GetUsersData = {}): Observable<GetUsersResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/users',
            query: {
                role: data.role,
                email: data.email,
                label_id: data.labelId,
                sort: data.sort,
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Create a user.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Error OK
     * @returns UserWithIncludes Created
     * @throws ApiError
     */
    public createUser(data: CreateUserData): Observable<CreateUserResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/users',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get an user record
     * @param data The data for the request.
     * @param data.id
     * @returns UserWithIncludes OK
     * @throws ApiError
     */
    public getUserById(data: GetUserByIdData): Observable<GetUserByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/users/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a user.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns UserWithIncludes OK
     * @throws ApiError
     */
    public updateUserById(data: UpdateUserByIdData): Observable<UpdateUserByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/users/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class WebhooksService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get all registered webhooks
     * @param data The data for the request.
     * @param data.page The page of the results to retrieve. **Note**: It's almost never necessary to use this parameter directly, the URL should be retrieved from the `Link` header.
     *
     * @param data.perPage The number of results to retrieve for this page.
     * @returns Webhook OK
     * @throws ApiError
     */
    public getWebhooks(data: GetWebhooksData = {}): Observable<GetWebhooksResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/webhooks',
            query: {
                page: data.page,
                per_page: data.perPage
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Register a webhook.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Webhook Created
     * @throws ApiError
     */
    public createWebhook(data: CreateWebhookData): Observable<CreateWebhookResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/webhooks',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Get a registered webhook
     * @param data The data for the request.
     * @param data.id
     * @returns Webhook OK
     * @throws ApiError
     */
    public getWebhookById(data: GetWebhookByIdData): Observable<GetWebhookByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/webhooks/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Delete a webhook.
     * @param data The data for the request.
     * @param data.id
     * @returns Webhook OK
     * @throws ApiError
     */
    public deleteWebhookById(data: DeleteWebhookByIdData): Observable<DeleteWebhookByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/webhooks/{id}',
            path: {
                id: data.id
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                500: 'Internal Server Error'
            }
        });
    }
    
    /**
     * Update a webhook.
     * @param data The data for the request.
     * @param data.requestBody
     * @param data.id
     * @returns Webhook OK
     * @throws ApiError
     */
    public updateWebhookById(data: UpdateWebhookByIdData): Observable<UpdateWebhookByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/webhooks/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                422: 'Unprocessable Entity',
                500: 'Internal Server Error'
            }
        });
    }
    
}

@Injectable({
    providedIn: 'root'
})
export class WebhookNotificationsService {
    constructor(public readonly http: HttpClient) { }
    
    /**
     * Get the notifications for a specific webhook
     * @param data The data for the request.
     * @param data.webhookId
     * @returns WebhookNotificationWithIncludes OK
     * @throws ApiError
     */
    public getWebhookNotificationsByWebhookId(data: GetWebhookNotificationsByWebhookIdData): Observable<GetWebhookNotificationsByWebhookIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/webhooks/{webhook_id}/notifications',
            path: {
                webhook_id: data.webhookId
            },
            errors: {
                400: 'Bad Request',
                401: 'Unauthorized',
                403: 'Forbidden',
                404: 'Not Found',
                500: 'Internal Server Error'
            }
        });
    }
    
}